<template>
    <div class="error-page">
        <div class="error-code">4<span>0</span>0</div>
        <div class="error-desc">由于被认为是客户端对错误，服务器无法或不会处理当前请求</div>
        <div class="error-qq">例如：畸形的请求语法、无效的请求信息帧或者虚拟的请求路由</div>
        <div class="error-qq">服务器无法或不会处理当前请求</div>
        <div class="error-handle">
            <router-link to="/login">
                <el-button type="primary" size="large">返回登陆页</el-button>
            </router-link>
            <el-button class="error-btn" type="danger" size="large">数据恢复</el-button>
            <el-button class="error-btn" type="primary" size="large" @click="goBack">返回上一页</el-button>
        </div>
    </div>
</template>

<script>

export default {
    methods: {
        goBack() {
            this.$router.go(-1);
        },
    }
}
</script>


<style scoped>
.error-page {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #f3f3f3;
    box-sizing: border-box;
}

.error-code {
    line-height: 1;
    font-size: 250px;
    font-weight: bolder;
    color: #2d8cf0;
}

.error-code span {
    color: #00a854;
}

.error-desc {
    font-size: 30px;
    color: #777;
}

.error-qq {
    font-size: 20px;
    color: #777;
}

.error-handle {
    margin-top: 30px;
    padding-bottom: 200px;
}

.error-btn {
    margin-left: 10px;
}
</style>
